<div class="agenda-datepicker">
    <div class="date-container">{{ value | moment:AGENDA_DATE_FORMAT }}</div>
    <div class="calendar-button" (click)="openPicker()">
        <ion-icon icon="calendar-outline"></ion-icon>
    </div>
    <app-datepicker
        #picker
        [max]="maxDate"
        [showInput]="false"
        [value]="value"
        (changed)="handleSelectDay($event)">
    </app-datepicker>
</div>
